import Vue from "vue"

/**
 * 创建全局挂载的组件
 * 以避免太多复杂的状态来设置，导致状态杂乱的问题
 * @param Component
 * @param props
 */
export default function create(Component, props) {
  // 利用 Vue.extend 创建子类
  const Creator = Vue.extend(Component)
  // 子类创建好后实例化
  const component = new Creator({ propsData: props })

  // 实例化后挂载
  component.$mount()
  document.body.appendChild(component.$el)

  // 设置移除方法
  component.remove = () => {
    document.body.removeChild(component.$el)
    component.$destroy()
  }

  return component
}
